export const NEW_ROW_ID_SENTINEL = 'NEW_ROW' as const;

/** Business cards on each "Businesses overview" page when the bundle has no
 *  `itemsPerPage`. The slide allows from 1 to 4. */
export const BUSINESSES_OVERVIEW_DEFAULT_ITEMS_PER_PAGE = 2;
